/**
 * Templates panel UI state (document tabs). List data stays in IfsDocsAccordionContent;
 * refreshTrigger coordinates refetch requests from sidebar/accordion/route changes.
 */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  /** Incremented when Templates list should refetch (sidebar/accordion re-click). */
  refreshTrigger: 0,
};

const templatesPanelSlice = createSlice({
  name: "templatesPanel",
  initialState,
  reducers: {
    requestRefreshTemplates: (state) => {
      state.refreshTrigger = (state.refreshTrigger || 0) + 1;
    },
  },
});

export const { requestRefreshTemplates } = templatesPanelSlice.actions;
export default templatesPanelSlice.reducer;
